export interface IDeveloperOrg {
  countryCode?: string;
  email?: string;
  id?: string;
  language?: string;
  name?: string;
  timezone?: string;
  website?: string;
}
